import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
/*
 *  Art Swatches
 *    Scripts to control swatches on art products.
 *
 *  Version:
 *    1.0.0 - 2021/09/21
 */

import { generatePicture, printMoney, t } from "@process-creative/slate-theme-tools";
import { ON_VARIANT_CHANGE } from "../../objects/variant/VariantSelector";
export var SELECTOR_ART_SWATCHES_CONTAINER = '[data-art-swatches]';
var SELECTOR_SWATCH_MODAL_TRIGGER = '[data-swatches-modal-trigger]';
var SELECTOR_SWATCHES_BACK = '[data-swatches-back]';
export var SELECTOR_FRAME_OPTION = '[data-frame-option]';
export var SELECTOR_PRINT_OPTION = '[data-print-option]';
var SELECTOR_PRICE_ELEMENT = '[data-product-money]';
var SELECTOR_NEXT_BTN = '[data-step-button-next]';
var SELECTOR_FRAME_IMAGE = '[data-product-frame-image]';
var SELECTOR_SWATCH_GROUP = '[data-swatch-group]';
var SELECTOR_SWATCH_OBJECT = '[data-swatch-object]';
var SELECTOR_MOBILE_FRAME_TRIGGER = '[data-mobile-frame-modal-trigger]';
var ATTR_STEP = 'data-step';
var ATTR_STEP_BTN = 'data-step-button';
var ATTR_FRAME_SIZE = 'data-frame-size';
export var ATTR_OPTION_VARIANT_ID = 'data-option-variant-id';
var ATTR_FRAME_VARIANT_PRICE = 'data-frame-variant-price';
var ATTR_FRAME_VARIANT_IMG = 'data-frame-variant-img';
var ATTR_PRINT_VARIANT_PRICE = 'data-print-variant-price';
var CLASS_MODAL_OPEN = 'is-modal-open';
var CLASS_ACTIVE = 'is-active';
var CLASS_SCROLL_LOCK = 'has-scroll-lock';
export var CLASS_SELECTED = 'is-selected';
var CLASS_VISIBLE = 'is-visible';
export function artSwatches(artSwatchModal, product, swatches) {
  var currentSwatchesStep = 1;
  // const printSizeOption = getPrintSizeOption();

  //Elements
  var body = document.querySelector('body');
  var productElement = product[0];
  var nextBtns = artSwatchModal.querySelectorAll(SELECTOR_NEXT_BTN);
  var steps = artSwatchModal.querySelectorAll("[".concat(ATTR_STEP, "]"));
  var stepBtns = artSwatchModal.querySelectorAll("[".concat(ATTR_STEP_BTN, "]"));
  var modalTriggers = productElement.querySelectorAll(SELECTOR_SWATCH_MODAL_TRIGGER);
  var stepBackBtns = artSwatchModal.querySelectorAll(SELECTOR_SWATCHES_BACK);
  var frameOptionBtns = artSwatchModal.querySelectorAll(SELECTOR_FRAME_OPTION);
  var frameImageContainers = productElement.querySelectorAll(SELECTOR_FRAME_IMAGE);
  var printOptionBtns = artSwatchModal.querySelectorAll(SELECTOR_PRINT_OPTION);
  var mobileModalButton = artSwatchModal.querySelector(SELECTOR_MOBILE_FRAME_TRIGGER);

  //Event Listeners
  modalTriggers.forEach(function (btn) {
    return btn.addEventListener('click', function (e) {
      return onSwatchModalTrigger(e);
    });
  });
  nextBtns.forEach(function (btn) {
    return btn.addEventListener('click', function (e) {
      return onNextClick(e);
    });
  });
  stepBtns.forEach(function (btn) {
    return btn.addEventListener('click', function (e) {
      return onStepClick(e);
    });
  });
  stepBackBtns.forEach(function (btn) {
    return btn.addEventListener('click', function (e) {
      return onStepBackClick(e);
    });
  });
  frameOptionBtns.forEach(function (btn) {
    return btn.addEventListener('click', function (e) {
      return onFrameOptionClick(e);
    });
  });
  printOptionBtns.forEach(function (btn) {
    return btn.addEventListener('click', function (e) {
      return onPrintOptionClick(e);
    });
  });
  $(document).on(ON_VARIANT_CHANGE, function (e, variant) {
    return onVariantChanged(variant);
  });
  function onSwatchModalTrigger(e) {
    e.preventDefault();
    if (artSwatchModal.classList.contains(CLASS_MODAL_OPEN)) {
      body.classList.remove(CLASS_SCROLL_LOCK);
      artSwatchModal.classList.remove(CLASS_MODAL_OPEN);
      moveToStep(1); // Reset the step
    } else {
      body.classList.add(CLASS_SCROLL_LOCK);
      artSwatchModal.classList.add(CLASS_MODAL_OPEN);
    }
  }
  function onNextClick(e) {
    if (currentSwatchesStep === steps.length) {
      onSwatchModalTrigger(e);
    } else {
      e.preventDefault();
      moveToStep(currentSwatchesStep + 1);
    }
  }
  function onStepClick(e) {
    e.preventDefault();
    moveToStep(e.currentTarget.getAttribute(ATTR_STEP_BTN));
  }
  function onStepBackClick(e) {
    if (currentSwatchesStep && currentSwatchesStep > 1) {
      moveToStep(currentSwatchesStep - 1);
    } else {
      onSwatchModalTrigger(e); // Closes modal
    }
  }

  function onVariantChanged(variant) {
    updateFramesButtons();
    printOptionBtns.forEach(function (btn) {
      return btn.classList.remove(CLASS_SELECTED);
    });
  }
  function onFrameOptionClick(e) {
    frameOptionBtns.forEach(function (btn) {
      return btn.classList.remove(CLASS_SELECTED);
    });
    var btn = e.currentTarget;
    btn.classList.add(CLASS_SELECTED);
    var image = btn.getAttribute(ATTR_FRAME_VARIANT_IMG);
    updateBundlePricing();
    updateBundleImage(image);
  }
  function onPrintOptionClick(e) {
    printOptionBtns.forEach(function (btn) {
      return btn.classList.remove(CLASS_SELECTED);
    });
    updateFramesButtons();
    var btn = e.currentTarget;
    btn.classList.add(CLASS_SELECTED);
    var size = btn.getAttribute(ATTR_FRAME_SIZE);

    //Find parent swatch and fake removing selection
    var swatchGroup = btn.closest(SELECTOR_SWATCH_GROUP);
    swatchGroup.querySelectorAll(SELECTOR_SWATCH_OBJECT).forEach(function (btn) {
      btn.classList.remove(CLASS_SELECTED);
    });
    updateFramesButtons(size);
    updateBundlePricing();
  }

  /**
   * Gets selected option from a nodelist of either frame or print elements
   * @param {*} nodeList w
   * @returns element with selected class
   */
  function getSelectedOption(nodeList) {
    var array = Array.from(nodeList);
    return array.find(function (btn) {
      return btn.classList.contains(CLASS_SELECTED);
    });
  }
  function updateBundleImage() {
    var image = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    if (!image) {
      frameImageContainers.forEach(function (el) {
        return el.innerHTML = '';
      });
    } else {
      frameImageContainers.forEach(function (el) {
        el.innerHTML = generatePicture(image, 850, [375, 750, 1650], 'c-art-swatches__frame-image');
      });
    }
  }
  function updateBundlePricing() {
    var selectedFrame = getSelectedOption(frameOptionBtns);
    var selectedPrint = getSelectedOption(printOptionBtns);
    var framePrice = parseInt(selectedFrame && selectedFrame.getAttribute(ATTR_FRAME_VARIANT_PRICE) || 0);
    var printPrice = parseInt(selectedPrint && selectedPrint.getAttribute(ATTR_PRINT_VARIANT_PRICE) || 0);
    var _swatches$getVariantD = swatches.getVariantData(),
      price = _swatches$getVariantD.price;
    var bundlePrice = price + framePrice + printPrice;
    var priceElements = productElement.querySelectorAll(SELECTOR_PRICE_ELEMENT);
    priceElements.forEach(function (el) {
      el.innerHTML = printMoney(bundlePrice, 'money_with_currency_format').replace('.00', '');
      el.setAttribute('data-money', bundlePrice);
    });
  }
  function updateFramesButtons() {
    var size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    //Update buttons for the selected variant
    frameOptionBtns.forEach(function (btn, i) {
      var btnSize = btn.getAttribute(ATTR_FRAME_SIZE);
      if (!size) frameOptionBtns.forEach(function (btn) {
        return btn.classList.remove(CLASS_SELECTED);
      });
      if (i === 0 && !btnSize) {
        //No frame option
        btn.classList.add(CLASS_SELECTED);
        updateBundlePricing();
        updateBundleImage();
      } else if (btnSize === size) {
        //frame buttons matching this size
        btn.classList.add(CLASS_VISIBLE);
      } else {
        btn.classList.remove(CLASS_VISIBLE);
      }
    });
  }
  function moveToStep() {
    var newStepNumber = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    currentSwatchesStep = parseInt(newStepNumber);
    steps.forEach(function (step) {
      if (step.getAttribute(ATTR_STEP) == newStepNumber) {
        step.classList.add(CLASS_ACTIVE);
      } else {
        step.classList.remove(CLASS_ACTIVE);
      }
    });
    stepBtns.forEach(function (btn) {
      if (btn.getAttribute(ATTR_STEP_BTN) == newStepNumber) {
        btn.classList.add(CLASS_ACTIVE);
      } else {
        btn.classList.remove(CLASS_ACTIVE);
      }
    });
    console.log(newStepNumber);
    console.log(mobileModalButton);
    if (newStepNumber == 2 && mobileModalButton) {
      mobileModalButton.classList.add(CLASS_VISIBLE);
    } else {
      mobileModalButton.classList.remove(CLASS_VISIBLE);
    }
  }
}